import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography } from '@mui/material';
import {
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppWidgetSummary,
  AppConversionRates,
} from '../../sections/@dashboard/app';


export default function DashboardPage() {
  const theme = useTheme();

  const [orderSummary, setOrderSummary] = useState({
    total: 100,
    open: 30,
    delivered: 60,
    cancelled: 10
  })

  const [pastWeek, setPastWeek] = useState({
      delivered: [40, 45, 32, 90, 20, 100, 66],
      cancelled: [10, 5, 7, 14, 20, 23, 7]
  })

  const [sales, setSales] = useState(
    [
      {
        label: 'Mon',
        value: 4000
      },
      {
        label: 'Tue',
        value: 4500
      },
      {
        label: 'Wed',
        value: 3200
      },
      {
        label: 'Thr',
        value: 9000
      },
      {
        label: 'Fri',
        value: 2000
      },
      {
        label: 'Sat',
        value: 10000
      },
      {
        label: 'Sun',
        value: 6600
      }
    ]
  )

  return (
    <>
      <Helmet>
        <title> Dashboard | FoodsyIndia </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 2 }}>
          Hi, Welcome back
        </Typography>
        <Typography variant="h4" sx={{ mb: 1 }}>
          Today's Orders
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total" total={orderSummary.total} icon={'icon-park-solid:transaction-order'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Open" total={orderSummary.open} color="info" icon={'mdi:truck-delivery'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Delivered" total={orderSummary.delivered} color="warning" icon={'mdi:package-delivered'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Cancelled" total={orderSummary.cancelled} color="error" icon={'fluent:calendar-cancel-16-filled'} />
          </Grid>
        </Grid>
        <Grid container sx={{mt: 2}} spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            <AppWebsiteVisits
              title="Orders"
              subheader="last 7 days"
              chartLabels={[
                '07/01/2023',
                '07/02/2023',
                '07/03/2023',
                '07/04/2023',
                '07/05/2023',
                '07/06/2023',
                '07/07/2023'
              ]}
              chartData={[
                {
                  name: 'Delivered',
                  type: 'column',
                  fill: 'solid',
                  data: pastWeek.delivered,
                },
                {
                  name: 'Cancelled',
                  type: 'column',
                  fill: 'gradient',
                  data: pastWeek.cancelled,
                }
              ]}
              
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits
              title="Order Status"
              chartData={[
                { label: 'Delivered', value: orderSummary.delivered },
                { label: 'Open', value: orderSummary.open },
                { label: 'Cancel', value: orderSummary.cancelled },
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.warning.main,
                theme.palette.error.main,
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates
              title="Sales"
              subheader="Past week"
              chartData={sales}
            />
          </Grid>


          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline
              title="Order Timeline"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  '1983, orders, $4220',
                  '12 Invoices have been paid',
                  'Order #37745 from September',
                  'New order placed #XF-2356',
                  'New order placed #XF-2346',
                ][index],
                type: `order${index + 1}`,
                time: faker.date.past(),
              }))}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
